module.exports = __webpack_public_path__ + "img/badgeWaitingLine.0273c027.svg";